<mat-card class="card">

    <div >
        <h2 style="text-align: center;">{{'REG_B1' | translate}}</h2>
        <p>{{'REG_P3' | translate}}</p>
        <form [formGroup]="resendForm" style="margin-bottom: 1rem;">
            <p class="label" [ngClass]="{'label-err': emailErr}">Email</p>
            <input placeholder="Email" formControlName='email' [ngClass]="{'error': emailErr}" (focus)="clearEmailErr()"
                (focusout)="focusOutCheck()">
            <p *ngIf="emailErr" class="error-text">{{emailErr}}</p>
        </form>
        <div style="display: flex; justify-content: center;">
            <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
            <button *ngIf="!loading" class="consentButton" mat-raised-button (click)="resendLink()">{{'REG_B1' |
                translate}}</button>
        </div>
    </div>
</mat-card>